/** @type {(value: string) => string} */
export const removeMask = (mask) =>
  mask.replace(/[.]/, '').replace('-', '').replace(/[.]/, '').replace(/\s/g, '').replace('(', '').replace(')', '')
